import { PauseIconCircle, PlayIconCircle } from "@/components/icons";
import { actualTrackState, playerCommandState } from "@/context/states";
import CloseIcon from "@mui/icons-material/Close";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Card, Fade, SvgIcon } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import theme from "../styles/theme";
import { BandMessageShareLikeButtons } from "./music/BandMessageShareLikeButtons";

export const PlaylistSmallSong = ({ onPlaySong, song, ref, ...props }) => {
  const [actualTrack] = useRecoilState(actualTrackState);
  const [playerCommand, setPlayerCommand] = useRecoilState(playerCommandState);
  const [open, setOpen] = useState(false);
  const router = useRouter();

  const [buttonsOpen, setButtonsOpen] = useState(false);

  useEffect(() => {
    console.debug("router", router);
  }, [router]);

  const handleOpen = () => setOpen(true);

  const handlePlaySong = (song) => {
    if (actualTrack?.id === song.id) {
      setPlayerCommand({ command: "pause" });
    } else {
      setPlayerCommand({ command: "play" });
      if (onPlaySong) {
        onPlaySong(song);
      }
    }
  };

  const overlayBox = {
    position: "absolute",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    width: "calc(100% + 4px)",
    height: "calc(100% + 4px)",
    zIndex: "500",
    background:
      actualTrack?.id === song?.id
        ? "linear-gradient(0deg, rgba(245,157,49,0.97) 0%, rgba(245,157,49,0.97) 100%)"
        : "linear-gradient(0deg, rgba(126,105,238,0.97) 0%, rgba(126,105,238,0.97) 100%)",
    border:
      actualTrack?.id === song?.id
        ? `2px solid ${theme.palette.primary.main}`
        : `2px solid ${theme.palette.secondary.main}`,
    transform: "translate(-2px, -2px)",
    [theme.breakpoints.up("sm")]: {
      border: "none",
      transform: "unset",
      width: "100%",
      height: "100%",
    },
  };

  return (
    <Card
      variant={
        actualTrack?.id === song?.id
          ? "PlaylistSmallSongPlay"
          : "PlaylistSmallSong"
      }
      elevation={0}
      sx={{
        position: "relative",
        pr: 2,
        [theme.breakpoints.up("sm")]: {
          py: 1,
          pl: 1,
        },
        mt: 1,
        backgroundColor: "transparent",
        borderWidth: "2px",
        borderStyle: "solid",
        borderColor: theme.palette.secondary.main,
      }}
    >
      {buttonsOpen ? (
        <Fade in={buttonsOpen}>
          <Box ref={ref} {...props} sx={overlayBox}>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{ height: "100%" }}
            >
              <BandMessageShareLikeButtons
                actualTrack={actualTrack}
                overlay={true}
                song={song}
                playlistSmall={true}
              />
            </Grid>
          </Box>
        </Fade>
      ) : (
        <></>
      )}
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item xs={10} sm={8}>
          <Grid container alignItems="center">
            <Grid item>
              <IconButton
                aria-label="Song Abspielen"
                color="secondary"
                onClick={() => {
                  handlePlaySong(song);
                }}
              >
                <SvgIcon
                  sx={{
                    fontSize: 56,
                  }}
                >
                  {actualTrack?.id !== song?.id ? (
                    <PlayIconCircle />
                  ) : (
                    <PauseIconCircle />
                  )}
                </SvgIcon>
              </IconButton>
            </Grid>
            <Grid item xs={8} md={6} lg={8}>
              <Typography
                variant="body1"
                sx={{
                  textTransform: "uppercase",
                  fontSize: "1.125rem",
                  textOverflow: "ellipsis",
                  width: "100%",
                  overflow: "hidden",
                  lineClamp: "2",
                  display: "-webkit-box",
                  "-webkit-line-clamp": "2",
                  "-webkit-box-orient": "vertical",
                  [theme.breakpoints.up("sm")]: {
                    fontSize: "1.375rem",
                  },
                }}
              >
                {song.title}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={2}
          sx={{ display: { xs: "block", sm: "none" }, zIndex: "1000" }}
          className="functionbuttons"
        >
          <IconButton
            aria-label="Mehr anzeigen"
            color="secondary"
            sx={{
              borderWidth: "2px",
              borderStyle: "solid",
              borderColor: buttonsOpen
                ? theme.palette.common.white
                : theme.palette.secondary.main,
              borderRadius: "0",
            }}
            onClick={() =>
              buttonsOpen ? setButtonsOpen(false) : setButtonsOpen(true)
            }
          >
            {buttonsOpen ? (
              <CloseIcon
                sx={{ fontSize: 20, color: theme.palette.common.white }}
              />
            ) : (
              <MoreHorizIcon sx={{ fontSize: 20 }} />
            )}
          </IconButton>
        </Grid>
        <Grid item xs="auto" sx={{ display: { xs: "none", sm: "block" } }}>
          <Stack direction="row" spacing={1}>
            <BandMessageShareLikeButtons
              actualTrack={actualTrack}
              overlay={true}
              song={song}
              playlistSmall={true}
              colorSecondary={true}
            />
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );
};
